import { render, staticRenderFns } from "./ResourceProjectCalendarView.vue?vue&type=template&id=60a3bfd0&"
import script from "./ResourceProjectCalendarView.vue?vue&type=script&lang=js&"
export * from "./ResourceProjectCalendarView.vue?vue&type=script&lang=js&"
import style0 from "./ResourceProjectCalendarView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports